import React from "react";
import ConfirmModal from "Components/confirmModal/ConfirmModal";
import t from "Utils/translation";
import TranslatedString from "Components/TranslatedString";

const withConfirmationModal = (Component, opts = {}) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      const name = opts.name || "Confirmation";
      this.closeConfirmModal = this.closeConfirmModal.bind(this);
      this[`open${name}Modal`] = this.openConfirmationModal.bind(this);
      this.doItAndClose = this.doItAndClose.bind(this);

      this.state = {
        confirmModalOpened: false,
        selectedResource: {},
        mainAction: undefined,
        body: undefined,
        name
      };
    }

    closeConfirmModal() {
      this.setState({ confirmModalOpened: false, selectedResource: {} });
    }

    openConfirmationModal(res, mainAction, body) {
      this.setState({ body, confirmModalOpened: true, selectedResource: res, mainAction });
    }

    doItAndClose() {
      this.state.mainAction(this.state.selectedResource[opts.idAttribute || "code"]);
      this.closeConfirmModal();
    }

    render() {
      const { name } = this.state;

      let dynamicProps = { [`open${name}Modal`]: this[`open${name}Modal`] };
      return (
        <div className="contentWrapper">
          <Component {...this.props} {...dynamicProps} closeConfirmModal={this.closeConfirmModal} />

          <ConfirmModal
            title={opts.title}
            text={this.state.body}
            textButton={opts.buttonLabel || "button.delete"}
            opened={this.state.confirmModalOpened}
            action={this.doItAndClose}
            handleClose={this.closeConfirmModal}
          />
        </div>
      );
    }
  };
};

export default withConfirmationModal;
